import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Modal } from 'react-bootstrap';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PlayCircleOutlineTwoToneIcon from '@mui/icons-material/PlayCircleOutlineTwoTone';
import PlayCircleTwoToneIcon from '@mui/icons-material/PlayCircleTwoTone';

import ReactPlayer from 'react-player'
const EventBoxCel = ({ item }) => {
  console.log('===== start log =======>');
  console.log(item);
  console.log('<==== end   =======');
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="post-card post_card_border">
        <div className="post-card__image" style={{ maxHeight: '190px', minHeight: '190px', overflow: 'hidden' }}>{item.video === null ? <Link to={`/events/${item?.slug}`}>
          <img alt="" src={item?.image} /></Link> : <Link to="#" onClick={handleShow} className="position-relative d-inline-block">
          <img alt="" src={item?.image} className="img-fluid" />

          <PlayCircleTwoToneIcon
            className="position-absolute top-50 start-50 translate-middle txtred"
            style={{ fontSize: "40px" }}
          />
        </Link>}</div>
        <div className="post-card__content bg-white">
          <div className="post-card__category"><span className='txtlgeay'>{item?.date}</span></div>
          <div className="post-card__title">
            <h2><Link to={`/events/${item?.slug}`} className='txtdgray'>{item?.title}</Link></h2>
          </div>
          <div className="post-card__date f12 mt-2"><Link to={`/events/${item?.slug}`} className='txtred'>READ MORE</Link></div>
        </div>
      </div>
      <Modal
        size="lg"
        show={show}
        backdrop="static"
        keyboard={false}
        contentClassName='border-0 rounded-0'
        onHide={() => handleClose()}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div onClick={() => handleClose()} aria-label="delete" size="small" className="position-absolute top-0 end-0 btn-out">
            <CloseIcon fontSize="small" className='text-white' />
          </div>
          <div>
            <ReactPlayer src={`https://www.youtube.com/embed/${item?.video}`} width="100%" height='460px' />



          </div>

        </Modal.Body>
      </Modal>
    </>
  )
}

export default EventBoxCel